import axios from 'axios';
import { useQuery } from 'react-query';
import { useMaterialsStore } from '../components/Stores/MaterialsStore';
import { getExposureById } from '../sp-firebase/exposureFB';
import { adjustExposureByMaterialPrices } from '../utils/exposureUtils';
import { useExposureStore } from '../components/Stores/exposureDataStore';
import { useCurrencyRates } from './useCurrencyRates';

export const useExposure = (accountId?: string) => {
  const { setNetExposure, setIsNetExposureLoading } = useExposureStore();

  const { pricesMap } = useCurrencyRates();
  //need to check why not use the priceMap of the currency convertion

  const { materialsPriceMap } = useMaterialsStore();

  const enable = accountId !== undefined;

  const fetchFunction = async () => {
    setIsNetExposureLoading(true);
    return await getExposureById(accountId!);
  };
  return useQuery('exposure', fetchFunction, {
    enabled: false,
    // enable,

    onSuccess: (data) => {
      if (data) {
        setNetExposure(adjustExposureByMaterialPrices(data, materialsPriceMap)); // pricesMap));
        setIsNetExposureLoading(false);
      }
    },
    onError: () => {
      setIsNetExposureLoading(false);
    },
    onSettled: () => {
      setIsNetExposureLoading(false);
    },
  });
};

interface UpdateNetExposureTriggerParams {
  accountId: string;
  materialIds: string[];
}

export const triggerExposureCalc = async ({
  accountId,
  materialIds,
}: UpdateNetExposureTriggerParams): Promise<string> => {
  //@ts-expect-error environement var in window
  const fnUrl = window?.functionsUrl || 'https://us-central1-spotlock-b8afb.cloudfunctions.net/';
  //const directUrl = 'https://updatenetexposurebyaccountandmaterial-qyhfe6vura-uc.a.run.app/';
  try {
    const response = await axios.get<string>(fnUrl + 'updateNetExposureByAccountAndMaterial', {
      params: {
        accountId,
        materialIds: materialIds.join(','),
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error triggering exposure calculation:', error);
    return ' no data';
  }
};

export const triggerMonthTestALLACCOUNTS = async (): Promise<string> => {
  //@ts-expect-error environement var in window
  const fnUrl = window?.functionsUrl || 'https://us-central1-spotlock-b8afb.cloudfunctions.net/';
  //const directUrl = 'https://updatenetexposurebyaccountandmaterial-qyhfe6vura-uc.a.run.app/';
  try {
    const response = await axios.get<string>(fnUrl + 'testMonthlyRun');
    return response.data;
  } catch (error) {
    console.error('Error triggering exposure calculation:', error);
    return ' no data';
  }
};
